import React from "react";
import logo from "../images/logo.png";
import Nav from "../navigations/Nav";

export default function Header({ handleInputChange }) {
  return (
    <div className="header">
      <div className="logo">
        <img src={logo} alt="Logo" />
      </div>
      <Nav handleInputChange={handleInputChange} />
    </div>
  );
}
